import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { RoomAccountDeleteEventVO } from "@youm-front/room/domain";
import { RoomAccountEvents } from "../events";

@Injectable()
export class RoomAccountFacade {
  constructor(private readonly store: Store) {}

  roomAccountDeleteEvent(roomAccountDeleteEventVO: RoomAccountDeleteEventVO) {
    this.store.dispatch(
      RoomAccountEvents.roomAccountDeleteEvent({
        roomAccountDeleteEventVO
      })
    );
  }
}
